// extracted by mini-css-extract-plugin
export default {"modalBody":"modal_modalBody__QIS0i","checkbox":"modal_checkbox__8CBUK"};